<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>URL Encode & Decode</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Paste your text here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn :color="separate ? 'primary' : 'red'" dark @click="separate = !separate">
              Separate line:
              <v-icon right dark>{{ separate ? 'done' : 'clear' }}</v-icon>
            </v-btn>
            <v-btn color="primary" @click="encode()">Encode</v-btn>
            <v-btn color="primary" @click="decode()">Decode</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    text: '',
    result: '',
    separate: false
  }),
  methods: {
    encode() {
      if (this.separate) {
        const text = this.text.split('\n')
        this.result = text.map((val) => encodeURIComponent(val)).join('\n')
        return
      }
      this.result = encodeURIComponent(this.text)
    },
    decode() {
      if (!this.separate) {
        const text = this.text.replace(/\n|\r/g, '')
        this.result = decodeURIComponent(text)
        return
      }
      this.result = decodeURIComponent(this.text)
    }
  }
}
</script>

<style>
</style>